<template>
  <div class="meetings-layout">
    <div class="meetings-layout-top">
      <div class="inner-container">
        <div class="inner-top-logo">
          <img src="../assets/images/p-logo.svg" />
        </div>
        <div class="inner-top-back"></div>
        <div class="inner-top-left">
          <h3 class="white--text" style="float: left">
            {{ organizationName }}
          </h3>
        </div>
        <div class="inner-top-search pr-8">
          <v-text-field
            background-color="white"
            filled
            rounded
            dense
            hide-details
            placeholder="Sök"
            v-model="searchTerm"
            clearable
          ></v-text-field>
        </div>
        <div class="inner-top-middle"></div>
        <div class="inner-top-right"></div>
        <div class="inner-top-usermenu">
          <user-menu></user-menu>
        </div>
      </div>
    </div>

    <div class="meetings-layout-subtop-left">
      <create-organization></create-organization>
    </div>

    <div class="meetings-layout-left">
      <v-card elevation="4">
        <v-list>
          <v-list-item-group color="primary">
            <v-list-item exact :to="{ path: '/organization' }">
              <v-list-item-content>
                <v-list-item-title style="word-break: break-word;"
                  >Visa alla möten
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-subheader>Filtrera på organisation</v-subheader>

            <v-list-item
              v-for="(org, i) in organizations"
              :key="i"
              :to="{ name: 'organization', params: { orgId: org.id } }"
            >
              <v-list-item-content>
                <v-list-item-title
                  style="word-break: break-word;"
                  v-html="org.name"
                ></v-list-item-title>
                <v-list-item-subtitle>{{
                  org.isAdmin ? "Admin" : "Ej admin"
                }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </div>
    <div class="meetings-layout-subtop-right">
      <v-row>
        <v-col class="col-auto mr-auto"></v-col>
        <v-col class="col-auto pr-1">
          <create-meeting
            :disabled="!hasOrganisation || !organization"
            :organization="organization"
          ></create-meeting>
          <edit-organization
            :disabled="!hasOrganisation || !organization"
            :org="organization"
          ></edit-organization>
        </v-col>
      </v-row>
    </div>

    <div class="meetings-layout-right">
      <v-row style="margin-top: -16px" v-if="meetings.length > 0">
        <v-col class="col-4" v-for="meeting in meetings" :key="meeting.id">
          <v-card style="height: 100%;" @click="openMeeting(meeting.id)">
            <v-card-subtitle style="padding-bottom:0">
              {{ meeting.stateText }}
            </v-card-subtitle>
            <v-card-title style="word-break: break-word;padding-top:0">
              {{ meeting.name }}
            </v-card-title>
            <v-card-subtitle>
              {{
                meeting.date
                  .toDate()
                  .toLocaleString("sv-SE")
                  .replace(/:\d\d$/, "")
              }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col class="white--text">Inga möten registrerade.</v-col>
      </v-row>
    </div>
    <div class="meetings-layout-bottom"></div>
  </div>
</template>

<script>
import CreateMeeting from "@/components/meetings/CreateMeeting.vue";
import EditOrganization from "@/components/organizations/EditOrganization.vue";
import CreateOrganization from "@/components/organizations/CreateOrganization.vue";
import UserMenu from "@/components/UserMenu";

function filterPredicate(searchTerm, includeOrganization) {
  let term = "";
  if (searchTerm) {
    term = searchTerm.toLowerCase();
  }
  return m => {
    if (includeOrganization) {
      return (
        m.organizationName.toLowerCase().includes(term) ||
        m.name.toLowerCase().includes(term)
      );
    } else {
      return m.name.toLowerCase().includes(term);
    }
  };
}

function sortByName(a, b) {
  return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
}

export default {
  components: {
    UserMenu,
    CreateMeeting,
    EditOrganization,
    CreateOrganization
  },
  data: function() {
    return {
      showAllText: "Visa alla",
      searchTerm: ""
    };
  },
  computed: {
    organizations() {
      const result = {};

      this.meetingsFiltered.map(meeting => {
        result[meeting.organizationId] = {
          id: meeting.organizationId,
          name: meeting.organizationName,
          isAdmin: false
        };
      });

      this.$store.state.organizations.organizations.map(org => {
        if (result[org.id]) {
          result[org.id].isAdmin = true;
        } else {
          result[org.id] = {
            id: org.id,
            name: org.name,
            isAdmin: true
          };
        }
      });

      return Object.values(result)
        .filter(filterPredicate(this.searchTerm, false))
        .sort(sortByName);
    },
    organization() {
      if (this.$route.params.orgId) {
        const org = this.$store.getters["organizations/getOrganization"](
          this.$route.params.orgId
        );
        return org;
      } else {
        return null;
      }
    },
    organizationName() {
      const org = this.organization;
      if (org) {
        return org.name;
      } else {
        return "Alla möten";
      }
    },
    hasOrganisation() {
      return !!this.$route.params.orgId;
    },
    members() {
      return this.$store.getters["organizations/getMembers"](
        this.$route.params.orgId
      );
    },
    meetingsOriginal() {
      if (this.$route.params.orgId) {
        return this.$store.getters["meetings/getMeetings"]
          .map(a => {
            if (a.closed) {
              a.stateStatus = 4;
              a.stateText = "Avslutade möten";
            } else if (a.opened) {
              a.stateStatus = 0;
              a.stateText = "Pågående möte";
            } else if (a.inlet) {
              a.stateStatus = 1;
              a.stateText = "Registrera närvaro";
            } else if (a.published) {
              a.stateStatus = 2;
              a.stateText = "Publicerat möte";
            } else {
              a.stateStatus = 3;
              a.stateText = "Kommande möten";
            }
            return a;
          })
          .sort((a, b) => a.stateStatus - b.stateStatus);
      } else {
        return this.$store.getters["meetings/getMeetings"]
          .map(a => {
            if (a.closed) {
              a.stateStatus = 4;
              a.stateText = "Avslutade möten";
            } else if (a.opened) {
              a.stateStatus = 0;
              a.stateText = "Pågående möte";
            } else if (a.inlet) {
              a.stateStatus = 1;
              a.stateText = "Registrera närvaro";
            } else if (a.published) {
              a.stateStatus = 2;
              a.stateText = "Publicerat möte";
            } else {
              a.stateStatus = 3;
              a.stateText = "Kommande möten";
            }
            return a;
          })
          .sort((a, b) => a.stateStatus - b.stateStatus);
      }
    },
    meetingsFiltered() {
      if (this.searchTerm) {
        return this.meetingsOriginal.filter(
          filterPredicate(this.searchTerm, true)
        );
      } else {
        return this.meetingsOriginal;
      }
    },
    meetings() {
      const orgId = this.$route.params.orgId;

      if (orgId) {
        return this.meetingsFiltered.filter(m => m.organizationId === orgId);
      } else {
        return this.meetingsFiltered;
      }
    }
  },
  methods: {
    clearSearchTerm() {
      this.searchTerm = "";
    },
    openMeeting(id) {
      this.$router.push({
        name: "meeting",
        params: { meetingId: id }
      });
    }
  }
};
</script>

<style>
.meetings-layout {
  height: 100vh;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: min-content min-content 1fr 12px;
  gap: 12px 12px;
  grid-template-areas:
    "meetings-layout-top meetings-layout-top"
    "meetings-layout-subtop-left meetings-layout-subtop-right"
    "meetings-layout-left meetings-layout-right"
    "meetings-layout-bottom meetings-layout-bottom";
}

.meetings-layout-top {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 6px;
  padding-bottom: 6px;
  background: #002435;
  -webkit-box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);
  grid-area: meetings-layout-top;
}

.meetings-layout-subtop-left {
  padding-top: 12px;
  grid-area: meetings-layout-subtop-left;
}
.meetings-layout-subtop-right {
  grid-area: meetings-layout-subtop-right;
  padding-right: 24px;
}

.meetings-layout-left {
  height: 100%;
  padding-left: 16px;
  padding-bottom: 16px;
  width: 300px;
  overflow-y: scroll;
  grid-area: meetings-layout-left;
}

.meetings-layout-right {
  height: 100%;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 16px;
  padding-right: 16px;
  overflow-y: scroll;
  grid-area: meetings-layout-right;
}

.meetings-layout-bottom {
  grid-area: meetings-layout-bottom;
}

.inner-container {
  display: grid;
  grid-template-columns: 36px auto 1fr auto auto auto auto;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "inner-top-logo inner-top-back inner-top-left inner-top-search inner-top-middle inner-top-right inner-top-usermenu";
}

.inner-top-logo {
  padding-top: 2px;
  grid-area: inner-top-logo;
  margin-right: 12px;
  align-self: end;
}

.inner-top-back {
  padding-top: 2px;
  width: 36px;
  grid-area: inner-top-back;
}

.inner-top-left {
  padding-top: 1px;
  margin-left: 12px;
  align-self: center;
  grid-area: inner-top-left;
}

.inner-top-search {
  grid-area: inner-top-search;
}

.inner-top-middle {
  grid-area: inner-top-middle;
}

.inner-top-right {
  grid-area: inner-top-right;
}

.inner-top-usermenu {
  grid-area: inner-top-usermenu;
}

.icon-button-container {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "icon-button-text icon-button-icon";
}

.icon-button-text {
  grid-area: icon-button-text;
  align-self: self-end;
}

.icon-button-icon {
  grid-area: icon-button-icon;
}
</style>
